import { render, staticRenderFns } from "./shopping-duihuan.vue?vue&type=template&id=358eadc3&scoped=true&"
import script from "./shopping-duihuan.vue?vue&type=script&lang=js&"
export * from "./shopping-duihuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358eadc3",
  null
  
)

export default component.exports